import React from 'react';

export default function SubscriptionWizardStep1() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Nova Assinatura - Etapa 1</h1>
      <p>Bem-vindo ao Wizard de Assinatura. Esta é a primeira etapa.</p>
    </div>
  );
} 